import qs from 'qs';
import { isString } from './type-guards.js';

const parse = (urlPart, ignoreQueryPrefix = false)=>qs.parse(urlPart.substring(urlPart.indexOf('?') + 1), {
        ignoreQueryPrefix
    })
;
const stringify = (params, noQuestionMark = false, keyDivision = '&', valueDivision = '=', encode = true)=>valueDivision === '=' ? `${noQuestionMark ? '' : '?'}${qs.stringify(params, {
        delimiter: keyDivision,
        arrayFormat: 'comma',
        encode
    })}` : Object.entries(params).reduce((acc, [key, value], index)=>`${acc}${!index ? noQuestionMark ? '' : '?' : keyDivision}${key}${valueDivision}${value}`
    , '')
;
const toQueryParams = (params, noQuestionMark = false)=>{
    const queryParams = Object.entries(params).map(([key, value])=>{
        if (Array.isArray(value)) {
            return `${key}=${value.join(',')}`;
        }
        return `${key}=${isString(value) ? value : stringify(value, true, '|', ':')}`;
    });
    const queryString = queryParams.join('&');
    return noQuestionMark ? queryString : `?${queryString}`;
};

export { parse, stringify, toQueryParams };
//# sourceMappingURL=query.js.map
